import { ApiResponse } from '../../../types/ApiResponse';
import { TomTomKeyResponse } from '../../../types/TomTomKey';
import { getRootApiURL } from '../../../utils/urlUtils';
import apiCall from '../../apiCall/apiCall';

class TomTomKey {
  static fetch(signal?: AbortSignal): Promise<ApiResponse<TomTomKeyResponse>> {
    return apiCall('GET', 'tom_tom_key', undefined, signal, getRootApiURL()) as Promise<
      ApiResponse<TomTomKeyResponse>
    >;
  }
}

export default TomTomKey;
